import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IProjectPanelStyles {
  root?: IStyle;
}

export interface IProjectPanelClassNames {
  root: string;
}

export const projectPanelStylesDefault = (_theme: IH2OTheme): Partial<IProjectPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
